import { palettes, type ThemeName } from '~/utils/colors/palettes'

interface UseThemeReturn {
  currentTheme: Ref<ThemeName>
  setTheme: (themeName: ThemeName) => void
  availableThemes: ThemeName[]
}

export const useTheme = (): UseThemeReturn => {
  const currentTheme = useState<ThemeName>('theme', () => 'olive')

  const setTheme = (themeName: ThemeName): void => {
    currentTheme.value = themeName
  }

  return {
    currentTheme,
    setTheme,
    availableThemes: Object.keys(palettes) as ThemeName[]
  }
}
